import styled from "styled-components";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

/* Container do Swiper */
export const StyledSwiperContainer = styled.div`
  width: 100%;
  padding: 20px 0;

  .swiper {
    padding-bottom: 40px; /* Espaço extra para os dots */
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: white;
    font-size: 24px;
    transition: opacity 0.3s ease-in-out;
  }

  .swiper-button-prev:hover,
  .swiper-button-next:hover {
    opacity: 0.7;
  }

  .swiper-pagination-bullet {
    background-color: #fff;
    opacity: 0.6;
  }

  .swiper-pagination-bullet-active {
    background-color: #1B73DA;
    opacity: 1;
  }
`;

/* Cada Slide */
export const ScoreSlide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  background: #1a1d23;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease-in-out;
  width: 90%;
  max-width: 400px; /* Ajuste automático */

  &:hover {
    transform: scale(1.05);
  }
`;

/* Logo dos times */
export const TeamLogo = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin: 5px;
`;

/* Texto do placar */
export const ScoreText = styled.span`
  font-size: 28px;
  font-weight: bold;
  color: #ffffff;
`;

/* Container de times */
export const ScoreTeams = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

/* Data do Jogo */
export const TextMatchDate = styled.div`
  width: 100%;
  text-align: center;
  border: solid 1px #252526;
  padding: 5px;
  border-radius: 6px;
  font-family: "Rubik";
  font-size: 14px;
  margin-bottom: 10px;
`;

/* Informações de cada time */
export const TeamInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 12px;
    color: #fff;
    font-family: "Rubik";
    text-align: center;
  }

  b {
    font-size: 14px;
    color: #848484;
    font-family: "Rubik";
    text-align: center;
  }
`;
